// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#lazy-business-map[data-v-1bc7a270]{min-height:300px}@media screen and (max-width:960px){#lazy-business-map[data-v-1bc7a270]{min-height:250px}}.main-map[data-v-1bc7a270]{height:300px;overflow:hidden;position:relative;width:100%;z-index:0}@media screen and (max-width:960px){.main-map[data-v-1bc7a270]{height:250px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
